import Cookies from 'js-cookie'
import { returnStringOrNull } from '../utils/type-check'

const cookieBannerElement = document.querySelector('.cookie-banner')
const cookieButtonCloseBanner = document.querySelector(
  '.js-close-cookie-banner'
)

class Cookie {
  constructor() {
    if (cookieBannerElement) {
      const isCookieAllowed = Cookies.get('cookieAllowed')

      // Cookies can only return a string, not a boolean...
      if (returnStringOrNull(isCookieAllowed) === 'false') {
        this.openCookieBanner()

        // Set add event listeners for the closing of the cookie banner.
        if (cookieButtonCloseBanner) {
          cookieButtonCloseBanner.addEventListener('click', () => {
            this.closeCookieBanner()
            this.setAcceptCookie()
            this.setAllCookie()
          })
        }
      }
    }
  }

  /**
   * Set cookie that this user accepts cookies.
   */
  setAcceptCookie() {
    Cookies.set('cookieAllowed', 'true', { expires: 31 })
  }

  setAllCookie() {
    // Set all cookies here
  }

  /**
   * Open cookie banner.
   */
  openCookieBanner() {
    cookieBannerElement.classList.add('js-visible')
  }

  /**
   * Close cookie banner.
   */
  closeCookieBanner() {
    cookieBannerElement.classList.remove('js-visible')
  }
}

export default new Cookie()
